import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column; 

    align-items: center;
    justify-content: center;
    
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 2rem;
    width: 100%;
    max-width: 800px;
`;


export const RankingCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    margin: .2rem;
    width: 100%;
    .rank {
        font-style: italic;
        font-size: small;
    }
    .ranking-box {
        display: flex;
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: left;
        background: white;
        border-radius: 20px;
        padding: 0rem 2rem;
    }
    .ranking-box-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        margin: 1rem;
    }

    .progress {
        height: .7rem;
        border-radius: 4px;
    }

    .bg-info {
        background-color: #FA124F !important;
    }

    .bg-sucess {
        background-color: #FA124F !important;
    }

    img {
        height: 50px;
        width: 50px;
        border-radius: 50%;
    }
`;

export const Button = styled.button`
    background: none;
    border: none;
    color: grey;
`;

export const InfoCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 0rem;
    padding: .3rem .5rem;
    background-color: rgb(118,118,128,.12);
    border-radius: 9px;

    .info-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 8rem;
    }

`;


export const ButtonSwitch = styled.button`
    display: flex;
    width: 80px;
    height: 28px;
    align-items: center;
    justify-content: center;
    border: none;
    color: black;
    font-family: Inter;
    font-weight: 400;
    font-size: large;
    border-radius: 7px;
    padding: 0rem 1rem;
`;
